import { styled } from '@mui/material/styles';

export const Container = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',

  position: 'absolute',
  top: '0',
  left: '0',
  right: '0',

  padding: '1.5rem 1.6rem',
});

export const MintscanIconContainer = styled('div')({
  width: '16rem',
  height: '2.5rem',

  '& > svg': {
    width: '16rem',
    height: '2.5rem',
  },
});

export const RightContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',

  columnGap: '2rem',
});

export const IconContainer = styled('div')({
  width: '3.2rem',
  height: '3.2rem',
  '& > svg': {
    width: '3.2rem',
    height: '3.2rem',
  },
});

export const DocIconContainer = styled('div')({
  width: '1.6rem',
  height: '1.6rem',
  '& > svg': {
    width: '1.6rem',
    height: '1.6rem',
  },
});
